<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Employee</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/questions/index"> Feedback </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Questionnaire  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveProduct()" >


     <b-modal
  id="yesNoModal"
  title="Select Choice"
  hide-footer
 
>

  <b-form-checkbox-group
    v-model="tempChoice"
    :options="yesNoOptions"
    stacked
  />
  <input  v-model="newchoise" placeholder="Enter New Choice"  style="font-size: small; width: 50%;" class="form-control bdr-rad mb-1" >
  <small class="text-danger" v-if="choiceError">
    Please select at least one option
  </small>
  <button
  type="button"
  class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
  @click="AddChoice"
>
  Add New Choice
</button>
  <button
  type="button"
  class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
  @click="saveChoice"
>
 Save
</button>
  <button
  type="button"
  class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
  
>
 Cancel
</button>
</b-modal>                 

<div class="row">
 
  
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Enter Questionnaire Name </label>
            <input  v-model="all_data.q_name" style="font-size: small;" class="form-control bdr-rad" required>
    </div> 
  </div>

  <div style="margin-top: 27px;" class="col-md-1  ms-2">

 <div class="form-check">
  <input
    class="form-check-input"
    type="radio"
    name="userType"
    id="anonymous"
    v-model="all_data.userchech"
    value="Anonymous"
    checked
  >
  <label class="form-check-label" for="anonymous">
    Anonymous
  </label>
</div>
</div>

 <div style="margin-top: 27px;" class="col-md-2  ms-1">

<div class="form-check">
  <input
    class="form-check-input"
    type="radio"
    name="userType"
    id="showContact"
    v-model="all_data.userchech"
    value="Show Contact"
  >
  <label class="form-check-label" for="showContact">
    Show Contact
  </label>
</div>



  </div>

  
</div>





<div class="card custom_bdr_rds">
<div class="card-body custom_bdr_rds">
<h6 class="purchitem mb-2"><b>Add Questionnaire</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
              <th style="width: 2%;"></th>
                <th  >   
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> #</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Category</label>
                  </div>
                </th>
               
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Question</label>
                  </div>
                </th>
                <th style="width: 15%;">
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Remarks</label>
                  </div>
                </th>
                <th style="width: 15%;">
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Action</label>
                  </div>
                </th>
                <th> <div class="form-group custom-form ">
                    <label class="custom-label2"> Select</label>
                  </div>
                </th>
                <th> <div class="form-group custom-form ">
                    <label class="custom-label2"> Response Choices</label>
                  </div>
                </th>
               
                <th></th>
              
             
                
              
             
            </tr>
          </thead>
          <tbody>

            <tr v-for="(all_detail, index) in all_details" :key="all_detail.id">
              <td></td>
              <td>  <input v-model="all_detail.check" class="" type="checkbox" ></td>
              <td>{{all_detail.Category}}</td>
              <td>{{all_detail.Question}}</td>
              <td><input v-model="all_detail.Remark" class="form-control bdr-rad" style="font-size: small;"/></td>
              <td><v-select v-model="all_detail.question_type" label="label"  :options="choises"  @input="selectOption2(index)" ></v-select></td>
              <td><button
  type="button"
  class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
  @click="openChoiceModal(all_detail)"
  :disabled="!all_detail.question_type || all_detail.question_type.value !== 'multiple_choice'"
>
  Select Choices
</button></td>
<td>
  <span v-if="all_detail.reschoise && all_detail.reschoise.length">
    {{
      all_detail.reschoise
        .map(o => `${o.text}`)
        .join(', ')
    }}
  </span>
</td>

               <td>  <b-icon
      v-if="index === all_details.length - 1"
      @click="add"
      class="mt-2"
      width="8"
      type="button"
      icon="plus-lg"
      scale="2"
    ></b-icon></td>

                
              
              
            </tr>
            
            <tr v-for="key in count" :key="key" >
               <td>  <b-icon @click="remove" class="ms-3 me-3 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
              <td>  <input class="" v-model="detail[key].check" type="checkbox" ></td>
              <td>  <input type="" v-model="detail[key].Category"  style="font-size: small;" class="form-control " ></td>
              <td>  <input type="" v-model="detail[key].Question"  style="font-size: small;" class="form-control " ></td>
              <td>  <input type="" v-model="detail[key].Remark"  style="font-size: small;" class="form-control " ></td>
               <td><v-select v-model="detail[key].question_type" label="label" @input="selectOption(key)"  :options="choises"  ></v-select></td>
               <td> <button
  type="button"
  class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad"
  @click="openChoiceModal(detail[key])"
  :disabled="!detail[key].question_type || detail[key].question_type.value != 'multiple_choice'"
>
  Select Choices
</button></td>
<td>
  <span v-if="detail[key].reschoise && detail[key].reschoise.length">
   {{
      detail[key].reschoise
        .map(o => `${o.text}`)
        .join(', ')
    }}
  </span>
</td>
                 <td> <b-icon @click="add" class=" mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>


            </tr>
           
           


          </tbody>
      </table>

      </div>

</div>
</div>















   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Save</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadData()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
           
        total:0,
        selectedOption: null, // Store the selected option
        count: 0,
      choises:[
        { label: 'Multiple Choice', value: 'multiple_choice'},
        { label: 'Free Text', value: 'free_text'}
          ], 
          yesNoOptions: [
      
      ],
      newchoise:'',
      detail:[
            {},  
            ],
        all_data:{
          userchech: 'Anonymous'
        },
        all_details:[],
       
      
      
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
        

        methods : {

          selectOption(key){
            console.log(this.detail[key].question_type);
            if(this.detail[key].question_type.value=='free_text'){
              this.detail[key].reschoise = '';
              
            }
            
          },
          selectOption2(index){
            console.log(this.all_details[index].question_type);
            if(this.all_details[index].question_type.value=='free_text'){
              this.all_details[index].reschoise = '';
              
            }
            
          },
    
 openChoiceModal(row) {
  console.log(row);
  this.selectedRow = row

  if (!Array.isArray(row.reschoise)) {
    this.$set(row, 'reschoise', [])
  }

  // convert [{text,value}] → ['value']
  this.tempChoice = row.reschoise.map(o => o.value)

  this.choiceError = false
  this.$bvModal.show('yesNoModal')
},

  saveChoice(evt) {
     console.log('test');
  if (this.tempChoice.length === 0) {
    evt.preventDefault()
    this.choiceError = true
    return
  }

  const selectedObjects = this.tempChoice.map(val => {
    return this.yesNoOptions.find(opt => opt.value === val)
  })

  // remove undefined safety
  const cleanSelection = selectedObjects.filter(Boolean)

  // ✅ store text + value
  this.$set(this.selectedRow, 'reschoise', cleanSelection);
  this.$bvModal.hide('yesNoModal');
},
          async loadData() {
       
     
      try {
        const { data} = await  axios.get('/questions/loaddata',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_details = data.all_details;
         this.yesNoOptions = data.yesNoOptions;
       
        
        
      } catch (error) {
        console.log(error.response);
      }
    },

      async loadData2() {
       
     
      try {
        const { data} = await  axios.get('/questions/loaddata',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
       
         this.yesNoOptions = data.yesNoOptions;
       
        
        
      } catch (error) {
        console.log(error.response);
      }
    },


    async SaveProduct() {
       
      console.log(this.products);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/questions/create',{all_data:this.all_data,all_details:this.all_details,detail:this.detail},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/questions/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },


       async AddChoice() {
       
     
      try {
        const { data} = await  axios.post('/questions/addchoise',{newchoise:this.newchoise},{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         if(data.status==200){
          this.loadData2();
          this.newchoise='';
         }
        
       
        
        
      } catch (error) {
        console.log(error.response);
      }
    },


      add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },
       

     

    },
    
    }
    
    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
    